import React, { useState, useCallback } from 'react'

import { ButtonSection } from '@/components/Layout'
import Icon from '@/components/Icon'
import { Form, Row, Col, FormGroup, Label } from 'reactstrap'
import { ValidationBoundary, ValidationState, Validator } from '@/components/validation'
import ErrorBoundary from '@/components/ErrorBoundary'
import { Button } from '@/components/button'
import LoadingIndicator from '@/components/LoadingIndicator'
import Resx from '@/components/Resx'
import { NumericInput, Input } from '@/components/inputs'
import { MultiSelect } from '@/components/MultiSelect'
import cached from '@/internal-app/cached'
import { useLocalization } from '@/hooks/localization'

const SettingsForm = ({ settings, fetching, updating, onSave }) => {
  const { locale } = useLocalization()

  const [numberOfDaysBeforeTaskDueDate, setNumberOfDaysBeforeTaskDueDate] = useState(settings.numberOfDaysBeforeTaskDueDate)
  const [numberOfDaysBeforeReportSubmissionGroupDueDate, setNumberOfDaysBeforeReportSubmissionGroupDueDate] = useState(settings.numberOfDaysBeforeReportSubmissionGroupDueDate)
  const [cbsWsUrl, setCbsWsUrl] = useState(settings.cbsWsUrl)
  const [cbsWsUsername, setCbsWsUsername] = useState(settings.cbsWsUsername)
  const [cbsWsPassword, setCbsWsPassword] = useState('')
  const [companyMergeWhitelist, setCompanyMergeWhitelist] = useState(settings.companyMergeWhitelist)

  const handleSave = useCallback(() => {
    onSave({
      numberOfDaysBeforeTaskDueDate,
      numberOfDaysBeforeReportSubmissionGroupDueDate,
      cbsWsUrl,
      cbsWsUsername,
      cbsWsPassword,
      companyMergeWhitelist
    })
  }, [onSave, numberOfDaysBeforeTaskDueDate, numberOfDaysBeforeReportSubmissionGroupDueDate, cbsWsUrl, cbsWsUsername, cbsWsPassword, companyMergeWhitelist])
  if (fetching || updating) { return <LoadingIndicator /> }
  return (
    <ErrorBoundary>
      <ValidationBoundary>
        <Form>
          <Row>
            <Col sm='6'>
              <FormGroup>
                <Label style={{ display: 'block' }}><Resx name='Common.NumberOfDaysBeforeTaskDueDate' /></Label>
                <Validator name='numberOfDaysBeforeTaskDueDate' value={numberOfDaysBeforeTaskDueDate} required min={0} max={30}>
                  <NumericInput integerOnly value={numberOfDaysBeforeTaskDueDate} onChange={setNumberOfDaysBeforeTaskDueDate} />
                </Validator>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm='6'>
              <FormGroup>
                <Label style={{ display: 'block' }}><Resx name='Common.NumberOfDaysBeforeReportSubmissionGroupDueDate' /></Label>
                <Validator name='numberOfDaysBeforeReportSubmissionGroupDueDate' value={numberOfDaysBeforeReportSubmissionGroupDueDate} required min={0} max={30}>
                  <NumericInput integerOnly value={numberOfDaysBeforeReportSubmissionGroupDueDate} onChange={setNumberOfDaysBeforeReportSubmissionGroupDueDate} />
                </Validator>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm='6'>
              <FormGroup>
                <Label style={{ display: 'block' }}><Resx name='Common.CbsWsUrl' /></Label>
                <Validator name='cbsWsUrl' value={cbsWsUrl} required>
                  <Input value={cbsWsUrl} onChange={e => setCbsWsUrl(e.target.value)} />
                </Validator>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm='5'>
              <FormGroup>
                <Label style={{ display: 'block' }}><Resx name='Common.CbsWsUsername' /></Label>
                <Validator name='cbsWsUsername' value={cbsWsUsername} required>
                  <Input value={cbsWsUsername} onChange={e => setCbsWsUsername(e.target.value)} />
                </Validator>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm='5'>
              <FormGroup>
                <Label style={{ display: 'block' }}><Resx name='Common.CbsWsPassword' /></Label>
                <Input value={cbsWsPassword} type='password' onChange={e => setCbsWsPassword(e.target.value)} />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm='5'>
              <FormGroup>
                <Label><Resx name='Common.CompanyMergeWhitelist' /></Label>
                <MultiSelect
                  dataSource={cached.getCompanyTypes}
                  value={companyMergeWhitelist}
                  textField={locale === 'ar' ? 'name' : 'latinName'}
                  onChange={e => setCompanyMergeWhitelist(e.value)}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm='6'>
              <ButtonSection>
                <div className='ml-auto'>
                  <ValidationState render={({ isValid }) =>
                    <Button id='save-button' color='success' disabled={!isValid} onClick={handleSave} ><Icon name='save' /> <span><Resx name='Common.Save' /></span></Button>
                  } />
                </div>
              </ButtonSection>
            </Col>
          </Row>
        </Form>
      </ValidationBoundary>
    </ErrorBoundary>
  )
}

export {
  SettingsForm
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/settings/form.js